import React, {useState,useEffect} from 'react';
import _ from 'lodash'
import apiService from '../services/api';

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from '../components/MUI-DGToolbar';
import CustomPagination from '../components/MUI-DGPagination';

// const getData = async (folder,name) =>{
//     return await fetch('data/'+folder+name+'.json')
//     .then(response => response.json())
//     .then(data => {return data});
// }

// function Loading(){
//     return(
//         <div className="vh-100 d-flex justify-content-center">
//             <div className="align-self-center">
//                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>{loading}
//             </div>
//         </div>
//     )
// }

function Feedback(props){
    const [data, setData] = useState([]);

    useEffect(()=>{
        async function fetchData(){
            try {
                const response = await apiService.getRatings();
                setData(response.data || []);
            } catch (error) {
                console.error('Error fetching feedback data:', error);
                setData([]);
            }
        }
        fetchData();
    },[]);

    var dt = [];
    data.forEach((d)=>{
        if(d.rating === "Chưa tốt"){
            dt.push(d);
        }
    })

    function prettyTime(number){
        if(number < 10){
            return `0${number}`;
        }else{
            return number;
        }
    }

    function date(dateString){
        const d = new Date(dateString);
        return prettyTime(d.getDate())+"/"+prettyTime(d.getMonth()+1)+"/"+prettyTime(d.getFullYear())+" - "+prettyTime(d.getHours())+":"+prettyTime(d.getMinutes())+":"+prettyTime(d.getSeconds());
    }

    useEffect(()=>{
        if(!_.isEmpty(data)){
            for(var dt of data){
                dt.createAt = date(dt.createAt);
            }
        }
    })

    const columns = [
        { field: 'displayName', headerName: 'Nhân viên',        headerAlign: 'center', flex: 2},
        { field: 'mssv',        headerName: 'MSSV',             headerAlign: 'center', flex: 1,     align: "center"},
        { field: 'phoneNumber', headerName: 'Số điện thoại',    headerAlign: 'center', flex: 1,     align: "center"},
        { field: 'feedBack',    headerName: 'Góp ý',            headerAlign: 'center', flex: 5},
        { field: 'createAt',    headerName: 'Vào lúc',          headerAlign: 'center', flex: 2,     align: "center"},
        // {
        //   field: 'fullName',
        //   headerName: 'Full name',
        //   description: 'This column has a value getter and is not sortable.',
        //   sortable: false,
        //   width: 160,
        //   valueGetter: (params) =>
        //     `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        // },
    ];

    return(
        <>
            <div style={{minHeight: "100vh"}} className="main d-flex align-items-center justify-content-center">
                <div className="container p-3 shadow rounded">
                    <h3 className="pt-2 pb-2">FEEDBACK</h3>
                    <div style={{height: "680px", width: "100%"}}>
                        {(_.isEmpty(dt))?
                        <div className=" h-100 d-flex justify-content-center">
                            <div className="align-self-center">Không có dữ liệu</div>
                        </div>:
                        <DataGrid
                            rows={dt}
                            columns={columns}
                            pageSize={10}
                            checkboxSelection
                            getRowId={(row) => row._id}
                            components={{
                                Toolbar: CustomToolbar,
                                Pagination: CustomPagination,
                            }}
                            componentsProps={{
                                toolbar: { 
                                    fileName: "Lịch sử đánh giá" 
                                },
                            }}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'createAt', sort: 'desc' }],
                                },
                            }}
                        />}
                    </div>
                </div>
            </div>
        </>
    );    
}
export default Feedback;